import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EmployeeInstrumentList.html?raw';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import NewInstrumentForm from '../NewInstrumentForm/NewInstrumentForm';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
class EmployeeInstrumentList extends compose(_WidgetBaseSP) {

    templateString: string = template;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<Instrument>>>;

    private newInstrumentForm: MdsLax<InstanceType<typeof NewInstrumentForm>>;

    private instrumentTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["description", "ref_instruments_categorie.description"],
        "attributes": ["description", "ref_instruments_categorie.description"],
        "colspans": [1, 1],
        "headings": [(this as any).translations["EmployeeInstrumentList__Name"], (this as any).translations["EmployeeInstrumentList__Category"]],
        widths: [null, null],
        alignmentsHeading: [null, null],
        alignmentsRow: [null, null]
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<InstrumentData>): boolean {
        let node = cell.contentnode;
        let entitiy = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        return false;
    }

    private _emitHandle: any = null;
    private _onChange_StoreData(): void {
        let diffData = this.store.getDiffData();

        if (!this.table) {
            this.setupTable();
        }

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }

    getData(): Instrument[] {
        return this.store.getCurrentCompleteList();
    }

    getDiffFata(): EntityStoreData<Instrument>  {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    private setupTable(): void {
        this.table = new StaticTable();

        this.table.addLineConfig(this.instrumentTableLayout);
        this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditInstrument));
        this.table.addDefaultRowActionButton("delete", lang.hitch(this, this._onClickDeleteInstrument));

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        this.table.setupFromStore(this.store);

        this.table.setCyAttribute("employeeInstruments");
    }

    setup(data: Array<Instrument>): void {
        this.store.setup(data);
        this.setupTable();
    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);  

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onClickAddInstrument(): void {
        this._createNewInstrumentForm();
    }

    private _onClickEditInstrument(e: StaticTable.StaticTableRowGroup<Instrument>): void {
        this._createNewInstrumentForm(e.entity);
    }

    private _onClickDeleteInstrument(e: StaticTable.StaticTableRowGroup<Instrument>): void {
        this.store.deleteEntry(e.entity);
    }

    private _createNewInstrumentForm(instrument?: Instrument): void {
        var dlg: MdsLax<InstanceType<typeof GenericDialog>> = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;
        dlg.keepOpen = true;
        dlg.enableContentOverflow(true);

        this.newInstrumentForm = new NewInstrumentForm();

        if (instrument) {
            this.newInstrumentForm.setInstrument(instrument);
        }

        dlg.show(this.newInstrumentForm, this.translate("EmployeeInstrumentList__AddInstrument"), null, null, "okcancel", lang.hitch(this, this._onNewInstrumentDlgResponse, dlg, this.newInstrumentForm));
        dlg.disableButton("ok");

        this.newInstrumentForm.on("valid", lang.hitch(this, this._onValid_newInstrumentForm, dlg));
    }

    private _onValid_newInstrumentForm(dlg: MdsLax<InstanceType<typeof GenericDialog>>, isDirty: boolean): void {
        dlg.enableButton("ok");
    }

    private _onNewInstrumentDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof NewInstrumentForm>>, result: number): void {
        if (result >= 1) {
            var newInstrumentFormData = this.newInstrumentForm.getData();
            if (form.getInstrument()) {
                this._editInstrument(form.getInstrument(), newInstrumentFormData);          
            } else {
                this.store.addEntry(newInstrumentFormData);
            }
            dlg.close(1, true);   
        } else {
            dlg.close(-1, true);
        }
    }

    private _editInstrument(currentInstrument: Instrument, editedInstrument: Instrument): void {
        if (currentInstrument.description !== editedInstrument.description) {
            this.store.setEntityAttributeValue(currentInstrument.ID, "description", editedInstrument.description);
        }
        if (currentInstrument.ref_instruments_categorie.ID !== editedInstrument.ref_instruments_categorie.ID) {
            this.store.setEntityAttributeValue(currentInstrument.ID, "ref_instruments_categorie", editedInstrument.ref_instruments_categorie);
        }             
    }
    
}

export default mdsWidget(EmployeeInstrumentList);